export default __webpack_public_path__ + "static/media/logo.37f04c93.png";